import { DafGrantType, DafLoginType } from '@nab/x-auth-core';
import { CustomDAFUsernamePwdStrategy } from './custom-daf-username-pwd-auth-strategy';

/**
 * @class CustomDafProspectLoginStrategy
 * An auth strategy that loads the identity miniapp to generate a token using user's credentials.
 */
export class CustomDafProspectLoginStrategy extends CustomDAFUsernamePwdStrategy {
    /**
     * This function determines if the authConfig, that is set on the runtime is valid to invoke this Strategy
     * @param config
     * @returns
     */
    public supports(config) {
        return (
            config.tokenSource === 'DAF' &&
            config.grantType === DafGrantType.UsernamePassword && // This distinguishes with DafOnboardingAuthStrategy
            config.flags?.loginType === DafLoginType.USER_ONBOARDING && // This distinguishes with CustomDAFUsernamePwdStrategy
            (config.tokenType === 'Bearer' || config.tokenType === 'JWT') &&
            !!config.isSeed === !!this.isSeed
        );
    }
}
